import React, { Component } from 'react';
import {connect} from 'react-redux';
import {List} from "immutable";
import AppSidebar from "../components/AppSidebar";
import PageHeader from "../components/PageHeader";
import PanelGroupController from "../components/PanelGroupController";
import PanelHeaderItem from "../components/PanelHeaderItem";
import ActionButton from "../components/ActionButton";
import OrderTaggingRulesList from "./views/OrderTaggingRulesList";
import OrderTaggingRulePropertiesPanel from "./panels/OrderTaggingRulePropertiesPanel";
import AccountPropertiesPanel from "../customers/panels/AccountPropertiesPanel";
import AccountHolderPropertiesPanel from "../customers/panels/AccountHolderPropertiesPanel";
import {
  requestCreateOrderTaggingRule,
  requestEditOrderTaggingRule,
  requestDeleteOrderTaggingRule
} from "../actions/ShippingApiActions";

class OrderTaggingRulesPage extends Component {

  constructor(props) {
    super(props);
    this.handleSelectionChange = this.handleSelectionChange.bind(this);
    this.handlePanelItemSelection = this.handlePanelItemSelection.bind(this);
    this.handleDeleted = this.handleDeleted.bind(this);
    this.state = {
      ruleId: "",
      accountId: "",
      hasSelection: false,
      selectedPanelId: "rule"
    }
  }

  render() {
    return (
      <div className="ShippingPage OrderTaggingRulesPage SecurePage">
        <AppSidebar />
        <PageHeader title="Order Tagging Rules" backButton={false} />
        <div className="PageContainer">
          <OrderTaggingRulesList
            selectedId={this.state.ruleId}
            onSelectionChange={this.handleSelectionChange}
            onDeleted={this.handleDeleted}
            />
        </div>
        <div className="PanelContainer">
          <div className="header">
            <PanelHeaderItem label="Rule" id="rule" selectedId={this.state.selectedPanelId} onClick={this.handlePanelItemSelection} />
            <PanelHeaderItem label="Account" id="account" selectedId={this.state.selectedPanelId} onClick={this.handlePanelItemSelection} />
            <PanelHeaderItem label="Account Holder" id="customer" selectedId={this.state.selectedPanelId} onClick={this.handlePanelItemSelection} />
          </div>
          {this.renderPanels()}
          <PanelGroupController title="Actions">
            <ActionButton
              label="Create Rule"
              onClick={() => this.props.requestCreateOrderTaggingRule()} />
            <ActionButton
              label="Edit Rule"
              active={this.state.hasSelection}
              onClick={() => this.props.requestEditOrderTaggingRule(this.state.ruleId)} />
            <ActionButton
              label="Delete Rule"
              active={this.state.hasSelection}
              onClick={() => this.props.requestDeleteOrderTaggingRule(this.state.ruleId)} />
          </PanelGroupController>
        </div>
      </div>
    );
  }

  renderPanels() {
    switch (this.state.selectedPanelId) {
      case "account":
        return this.buildPanels(List([AccountPropertiesPanel]));
      case "customer":
        return this.buildPanels(List([AccountHolderPropertiesPanel]));
      default:
        return this.buildPanels(List([OrderTaggingRulePropertiesPanel]));
    }
  }

  buildPanels(panels) {
    return panels.map(x => this.buildPanel(x));
  }

  buildPanel(component) {
    switch(component) {
      case OrderTaggingRulePropertiesPanel:
        return <OrderTaggingRulePropertiesPanel
                key="OrderTaggingRulePropertiesPanel"
                expanded={true}
                ruleId={this.state.ruleId}
                />
      case AccountPropertiesPanel:
        return <AccountPropertiesPanel
                key="AccountPropertiesPanel"
                expanded={true}
                accountId={this.state.accountId}
                hasSelection={this.state.hasSelection}
                />
      case AccountHolderPropertiesPanel:
        return <AccountHolderPropertiesPanel
                key="AccountHolderPropertiesPanel"
                expanded={true}
                accountId={this.state.accountId}
                />
      default:
        return null;
    }
  }

  handleSelectionChange(ruleId, accountId) {
    this.setState({ruleId, accountId, hasSelection: true});
  }

  handleDeleted(ruleId) {
    if (this.state.ruleId === ruleId) {
      this.setState({ruleId: "", accountId: "", hasSelection: false});
    }
  }

  handlePanelItemSelection(id) {
    this.setState({selectedPanelId: id});
  }
}

export default connect(null, {
  requestCreateOrderTaggingRule,
  requestEditOrderTaggingRule,
  requestDeleteOrderTaggingRule
})(OrderTaggingRulesPage);
